import api from '../axiosClient';

export const getDidYouKnow = async (params = {}) => {
  const res = await api.get('/api/knowledge/did-you-know', { params });
  return res.data;
};

export const getThisWeekInHistory = async (params = {}) => {
  const res = await api.get('/api/knowledge/this-week', { params });
  return res.data;
};
